/* MYSTERY BOX — coming soon page.
   Countdown + notify signup only. Deliberately NOT drop-page.js: that script
   binds unconditionally to #cartToggle / #cartClose / #checkoutBtn and would
   throw on this page, taking the notify handler down with it. There is no cart
   here on purpose — nothing on this page routes to a buyable product before the
   drop opens.
   The notify POST is a faithful copy of drop-page.js initNotify, same Cloudflare
   proxy, same consent gate, differing only in `source`. */
(function () {
  "use strict";

  /* ---------- COUNTDOWN ---------- */
  (function initCountdown() {
    var root = document.getElementById("countdown");
    if (!root) return;
    var target = Date.parse(root.dataset.opens);
    if (isNaN(target)) return;

    var out = {
      d: root.querySelector('[data-unit="d"]'),
      h: root.querySelector('[data-unit="h"]'),
      m: root.querySelector('[data-unit="m"]'),
      s: root.querySelector('[data-unit="s"]')
    };
    var live = document.getElementById("cdLive");

    function pad(n) { return n < 10 ? "0" + n : String(n); }

    function tick() {
      var left = target - Date.now();
      if (left <= 0) {
        root.classList.add("is-open");
        if (live) live.textContent = "The drop is open.";
        Object.keys(out).forEach(function (k) { if (out[k]) out[k].textContent = "00"; });
        clearInterval(timer);
        return;
      }
      var s = Math.floor(left / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600);  s -= h * 3600;
      var m = Math.floor(s / 60);    s -= m * 60;
      if (out.d) out.d.textContent = pad(d);
      if (out.h) out.h.textContent = pad(h);
      if (out.m) out.m.textContent = pad(m);
      if (out.s) out.s.textContent = pad(s);
    }
    tick();
    var timer = setInterval(tick, 1000);
  })();

  /* ---------- HOLD TO OPEN ----------
     The signature interaction. Press and hold and the box strains against the
     seal, then refuses. It is the drop's whole proposition as a gesture: you
     can touch it, you cannot have it yet.

     Built on POINTER events so mouse, touch and pen share one code path, plus
     an explicit keyboard path, because the target is a real <button> and Space
     must do what a press does. */
  (function initHold() {
    var box   = document.getElementById("sealBox");
    var press = document.getElementById("sealPress");
    var out   = document.getElementById("sealRefuse");
    var hint  = document.getElementById("sealHint");
    var secret= document.getElementById("sealSecret");
    var cd    = document.getElementById("countdown");
    if (!box || !press) return;

    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var HOLD_MS = reduce ? 260 : 1150;

    /* Cycled so a second attempt is not a copy of the first. The box has a
       personality; repeating one line would flatten it. */
    var REFUSALS = ["Not yet.", "Friday.", "It stays sealed.", "Nice try.", "Still no."];
    /* Hyphen, not an em dash: house rule, and the manifesto printed inside the
       real box signs off the same way. */
    var SECRET =
      "Whoever keeps pulling at a sealed box is exactly who we made it for. " +
      "- Cult Handler 001";
    var SECRET_AT = 5;

    var attempts = 0, raf = null, timer = null, start = 0, holding = false, revealed = false;

    function paint(p) { box.style.setProperty("--hold", p.toFixed(3)); }

    /* 🔴 THE TIMER COMPLETES THE HOLD, NOT THE ANIMATION FRAME.
       An earlier version drove completion off the rAF loop, which hangs the
       whole interaction wherever frames are throttled: a background tab, a
       reduced-power device, or a browser that has stopped painting the page.
       Measured on a hidden tab: ZERO frames in 600ms, so the box strained for
       ever and never refused. setTimeout keeps running in all of those cases,
       so it owns the outcome and rAF only paints the strain. */
    function tick() {
      paint(Math.min((Date.now() - start) / HOLD_MS, 1));
      if (holding) raf = requestAnimationFrame(tick);
    }

    function begin(e) {
      /* Once it is open the box is not a tease any more, it is a door. */
      if (cd && cd.classList.contains("is-open")) return;
      if (holding) return;
      holding = true;
      if (e && e.pointerId != null && press.setPointerCapture) {
        try { press.setPointerCapture(e.pointerId); } catch (err) {}
      }
      box.classList.add("is-holding");
      if (hint) hint.classList.add("is-gone");
      start = Date.now();
      paint(0);
      timer = setTimeout(refuse, HOLD_MS);
      raf = requestAnimationFrame(tick);
    }

    function end() {
      if (!holding) return;
      holding = false;
      if (raf) { cancelAnimationFrame(raf); raf = null; }
      if (timer) { clearTimeout(timer); timer = null; }
      box.classList.remove("is-holding");
      /* The snap back is the point: it has to feel like the box won. */
      box.classList.add("is-snapping");
      paint(0);
      setTimeout(function () { box.classList.remove("is-snapping"); }, 420);
    }

    function refuse() {
      end();
      attempts++;
      if (out) {
        out.textContent = REFUSALS[(attempts - 1) % REFUSALS.length];
        out.classList.remove("show"); void out.offsetWidth; out.classList.add("show");
      }
      if (!revealed && attempts >= SECRET_AT && secret) {
        revealed = true;
        secret.textContent = SECRET;
        secret.hidden = false;
        /* A forced reflow, not requestAnimationFrame. rAF does not fire on a
           throttled or hidden page, and the line would then be unhidden but
           permanently stuck at opacity 0 — revealed and invisible. Reading
           offsetWidth flushes layout so the transition still has two states to
           animate between, without depending on a frame ever arriving. */
        void secret.offsetWidth;
        secret.classList.add("show");
      }
    }

    press.addEventListener("pointerdown", function (e) { e.preventDefault(); begin(e); });
    press.addEventListener("pointerup", end);
    press.addEventListener("pointercancel", end);
    press.addEventListener("pointerleave", end);
    /* a press interrupted by the tab going away must not resume mid-strain */
    document.addEventListener("visibilitychange", function () { if (document.hidden) end(); });

    press.addEventListener("keydown", function (e) {
      if (e.key === " " || e.key === "Enter") { e.preventDefault(); begin(null); }
    });
    press.addEventListener("keyup", function (e) {
      if (e.key === " " || e.key === "Enter") end();
    });
    press.addEventListener("blur", end);
  })();

  /* ---------- THE BOX NOTICES YOU ----------
     Desktop: the box leans toward the pointer and the halo brightens as you
     close on it. Mobile: the same lean, driven by scroll position instead.

     🔴 NO DeviceOrientation. iOS 13+ gates the gyro behind an explicit
     permission prompt that must follow a user gesture, so a tilt effect would
     cost every mobile visitor a system dialog before they had seen anything.
     Scroll is free, needs no permission, and reads almost identically. */
  (function initLean() {
    var box = document.getElementById("sealBox");
    if (!box) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    var MAXX = 10, MAXY = 6, MAXR = 1.6;
    var tx = 0, ty = 0, cx = 0, cy = 0, queued = false;

    function apply() {
      queued = false;
      /* eased toward the target so the box drifts rather than snapping */
      cx += (tx - cx) * 0.12;
      cy += (ty - cy) * 0.12;
      box.style.setProperty("--lx", (cx * MAXX).toFixed(2) + "px");
      box.style.setProperty("--ly", (cy * MAXY).toFixed(2) + "px");
      box.style.setProperty("--lr", (cx * MAXR).toFixed(3) + "deg");
      box.style.setProperty("--near", (1 - Math.min(Math.hypot(tx, ty), 1)).toFixed(3));
      if (Math.abs(tx - cx) > 0.001 || Math.abs(ty - cy) > 0.001) queue();
    }
    function queue() { if (!queued) { queued = true; requestAnimationFrame(apply); } }

    if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
      window.addEventListener("pointermove", function (e) {
        var r = box.getBoundingClientRect();
        tx = Math.max(-1, Math.min(1, (e.clientX - (r.left + r.width / 2)) / (r.width / 2)));
        ty = Math.max(-1, Math.min(1, (e.clientY - (r.top + r.height / 2)) / (r.height / 2)));
        queue();
      }, { passive: true });
    } else {
      window.addEventListener("scroll", function () {
        var r = box.getBoundingClientRect();
        var mid = r.top + r.height / 2, half = window.innerHeight / 2;
        ty = Math.max(-1, Math.min(1, (mid - half) / half));
        tx = ty * 0.35;
        queue();
      }, { passive: true });
    }
  })();

  /* ---------- THE COUNTDOWN ESCALATES ----------
     Someone landing on Friday morning should not get the same page as someone
     landing on Tuesday. Thresholds add classes; the CSS does the rest. */
  (function initEscalation() {
    var root = document.getElementById("countdown");
    var kicker = document.getElementById("sealKicker");
    if (!root) return;
    var target = Date.parse(root.dataset.opens);
    if (isNaN(target)) return;

    var HOUR = 3600e3, DAY = 24 * HOUR;
    var last = "";

    /* 🔴 "TODAY" IS A CALENDAR CLAIM, NOT AN ELAPSED-TIME ONE. This used to say
       "It opens today" for anything under 24 hours away, so at 5pm Thursday it
       announced that a Friday-noon drop opened today. Nineteen hours away is
       still tomorrow. Compare the calendar DATES instead, in the viewer's own
       timezone, because "today" is a claim about THEIR day: a drop at noon ET
       is already Friday for someone in Sydney. */
    function dayDelta(then, now) {
      var a = new Date(then), b = new Date(now);
      a.setHours(0, 0, 0, 0); b.setHours(0, 0, 0, 0);
      return Math.round((a - b) / DAY);
    }

    function state() {
      var now = Date.now();
      var left = target - now;
      var s = left <= 0 ? "open" : left < HOUR ? "imminent" : left < DAY ? "soon" : "far";
      var days = dayDelta(target, now);
      var key = s + "|" + days;
      if (key === last) return;
      last = key;
      document.body.classList.remove("t-far", "t-soon", "t-imminent", "t-open");
      document.body.classList.add("t-" + s);
      if (kicker) {
        kicker.textContent =
          s === "open"     ? "The seal is broken" :
          s === "imminent" ? "Minutes away" :
          days === 0       ? "It opens today" :
          days === 1       ? "It opens tomorrow" :
                             "Something is sealed";
      }
    }
    state();
    setInterval(state, 1000);
  })();

  /* ---------- TURN IT OVER: drag the 3D box ----------
     Six CSS faces in a preserve-3d space. Drag sets two rotations; when nobody
     is touching it, it turns slowly on its own so the section is never a dead
     object waiting to be discovered. */
  (function initCube() {
    var stage = document.getElementById("turnStage");
    var cube  = document.getElementById("cube");
    var hint  = document.getElementById("turnHint");
    if (!stage || !cube) return;

    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var rx = 22, ry = -28, vy = reduce ? 0 : 0.18;
    var dragging = false, lastX = 0, lastY = 0, touched = false, idle = 0;

    function draw() {
      cube.style.setProperty("--rx", rx.toFixed(2) + "deg");
      cube.style.setProperty("--ry", ry.toFixed(2) + "deg");
    }

    function frame() {
      if (!dragging) {
        /* drift back to idle spin only after the visitor has stopped, so their
           last flick is not immediately overwritten */
        idle++;
        if (idle > 40 || !touched) { ry += vy; }
      }
      draw();
      requestAnimationFrame(frame);
    }

    function down(e) {
      /* the stage is touch-action:none, so nothing is scrolling here anyway;
         preventDefault also stops the image-drag ghost on desktop */
      if (e.cancelable) e.preventDefault();
      dragging = true; touched = true; idle = 0;
      lastX = e.clientX; lastY = e.clientY;
      if (hint) hint.classList.add("is-gone");
      if (stage.setPointerCapture && e.pointerId != null) {
        try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      }
    }
    function move(e) {
      if (!dragging) return;
      ry += (e.clientX - lastX) * 0.45;
      /* 🔴 MINUS, not plus. This was flipped to `+` while the face geometry was
         still wrong, on the assumption that a larger rx meant more of the lid in
         view. Once the geometry was fixed that assumption inverted with it, and
         the vertical drag ended up backwards.

         What it does NOW, measured with a real downward drag: rx goes 22 -> -6,
         so dragging DOWN tips the box away and reveals less of the top, and
         dragging UP brings the top toward you. That is the direction Mudit
         asked for on 2026-09-09. Both conventions exist in 3D viewers, so this
         is a preference, not a correctness fix: do not "fix" it back on the
         assumption that down should show more of the top. */
      rx = Math.max(-70, Math.min(82, rx - (e.clientY - lastY) * 0.35));
      lastX = e.clientX; lastY = e.clientY;
      idle = 0;
      /* 🔴 PAINT HERE, not only in the idle loop. draw() used to be called
         exclusively from frame(), which is skipped entirely under
         prefers-reduced-motion — so for anyone with that setting on, the cube
         could not be dragged AT ALL: the rotation variables changed and nothing
         was ever written to the element. It also makes the drag track the
         finger on the same tick rather than the next animation frame. */
      draw();
    }
    function up() { dragging = false; idle = 0; }

    stage.addEventListener("pointerdown", down);
    stage.addEventListener("pointermove", move);
    stage.addEventListener("pointerup", up);
    stage.addEventListener("pointercancel", up);
    stage.addEventListener("pointerleave", up);
    /* 🔴 A RELEASE ANYWHERE ENDS THE DRAG. If a pointerup is missed — released
       outside the window, an interrupted gesture, a lost capture — `dragging`
       stays true and every later mouse movement over the page keeps spinning
       the box. Observed in testing: the pitch was driven to its -70 clamp by
       stray movement long after the gesture ended, leaving the viewer looking
       at the underside of the box. Listening on the window closes it. */
    window.addEventListener("pointerup", up);
    window.addEventListener("pointercancel", up);
    window.addEventListener("blur", up);

    /* The hold-to-open lid was removed after it repeatedly broke the box at
       rest. See the note in mystery-box-soon.css on .f-top. Rebuild it with a
       visual check at every step, not a numeric one. */

    draw();
    if (!reduce) requestAnimationFrame(frame);
  })();

  /* ---------- THE ODDS: 131 tiles, one lit ----------
     "1 in 131" is an abstraction until you see 131 of something with exactly
     one of them alight.

     ⚠ The lit tile is random and is NOT the real draw. The page says so; this
     code must never be wired to anything that decides an actual prize. */
  (function initOdds() {
    var grids = [document.getElementById("oddsA"), document.getElementById("oddsB")].filter(Boolean);
    var btn = document.getElementById("oddsShuffle");
    if (!grids.length) return;

    grids.forEach(function (g) {
      var n = parseInt(g.dataset.count, 10) || 0;
      /* one DocumentFragment, one insertion: 182 individual appends to a live
         DOM would lay out 182 times */
      var frag = document.createDocumentFragment();
      for (var i = 0; i < n; i++) frag.appendChild(document.createElement("span"));
      g.appendChild(frag);
    });

    function pick() {
      grids.forEach(function (g) {
        var kids = g.children;
        if (!kids.length) return;
        var prev = g.querySelector(".hit");
        if (prev) prev.classList.remove("hit");
        kids[Math.floor(Math.random() * kids.length)].classList.add("hit");
      });
    }
    pick();
    if (btn) btn.addEventListener("click", pick);
  })();

  /* ---------- FIT THE FIRST SCREEN ----------
     The box, the message slot and the clock must all be on the landing screen.

     🔴 THIS IS DONE IN JS ON PURPOSE, after four CSS attempts failed.
     A bounded container, flex-basis 0, an explicit max-height on the art and
     trimming the fixed furniture each left the clock EXACTLY 18px past the fold
     at every viewport size, while the flex algorithm reported a perfect fit
     (children plus gaps summed to the container height to the pixel). Freeing
     space just fed the art, because flex-grow reclaimed it, and the total stayed
     pinned 18px over. Measuring the real furniture and subtracting it is not
     elegant, but it is correct by construction and it is verifiable.

     Uses innerHeight, which on a phone IS the landing height including browser
     chrome, so it needs no svh/dvh guesswork. It re-runs on resize and on
     orientation change, and it is deliberately cheap: a handful of reads and one
     style write. */
  (function initFit() {
    var above = document.querySelector(".above");
    var box   = document.querySelector(".above .seal__box");
    if (!above || !box) return;

    var MIN = 130;   /* below this the art stops being worth showing */

    function fit() {
      box.style.height = "auto";
      /* everything in the strip except the art, plus the gaps between them */
      var used = 0;
      var gap = parseFloat(getComputedStyle(above).gap) || 0;
      var shown = 0;
      [].forEach.call(above.children, function (el) {
        if (getComputedStyle(el).display === "none") return;
        shown++;
        if (el !== box) used += el.getBoundingClientRect().height;
      });
      if (shown > 1) used += gap * (shown - 1);

      /* the container's own padding is inside the space we are dividing up but
         is not part of any child's height, so it has to be counted too — it was
         the last ~26px of shortfall. SAFETY absorbs sub-pixel rounding across
         six children and their gaps. */
      var acs = getComputedStyle(above);
      used += (parseFloat(acs.paddingTop) || 0) + (parseFloat(acs.paddingBottom) || 0);
      /* 6 left a consistent 11-12px shortfall at every viewport size tested,
         so the real rounding cost across six children, five gaps and the
         image's own box is about 18. Measured, not guessed. 30 leaves roughly a
         10px cushion on top of that, because a real handset can render the
         headline a hair taller than this emulator does and 2px of slack is not
         a margin, it is luck. */
      var SAFETY = 30;

      var top = above.getBoundingClientRect().top + window.scrollY;
      var avail = window.innerHeight - top - used - SAFETY;
      box.style.height = Math.max(MIN, Math.floor(avail)) + "px";
      box.style.flex = "0 0 auto";   /* stop grow reclaiming what we just freed */
    }

    fit();
    /* fonts change the headline's height, so refit once they land */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    /* a ResizeObserver on the strip catches every reflow that changes the
       furniture — a wrapped headline, a font swap, the hint hiding — which a
       window resize listener alone does not see */
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { ro.disconnect(); fit(); ro.observe(above); });
      [].forEach.call(above.children, function (el) { if (el !== box) ro.observe(el); });
    }
    window.addEventListener("resize", fit);
    window.addEventListener("orientationchange", function () { setTimeout(fit, 250); });
    /* the refusal slot is reserved, so a refusal never triggers a reflow here */
  })();

  /* ---------- NOTIFY -> Omnisend (same Cloudflare proxy as the drop page) ---------- */
  (function initNotify() {
    var form = document.getElementById("notifyForm");
    if (!form) return;
    var note = document.getElementById("notifyNote");
    var done = document.getElementById("notifyDone");
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!form.name.value.trim() || !form.email.value.trim()) { form.reportValidity(); return; }
      var btn = form.querySelector("button[type=submit]");
      btn.disabled = true; if (note) note.textContent = "Signing you up...";
      var consentEl = document.getElementById("notifyConsent");
      fetch("https://cult-racing.pages.dev/api/join", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name.value.trim(),
          phone: form.phone.value.trim(),
          email: form.email.value.trim(),
          consent: !!(consentEl && consentEl.checked),
          company: form.company.value, // honeypot
          source: "mystery-box-soon"
        })
      }).then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.ok) { form.hidden = true; if (done) done.hidden = false; }
          else { if (note) note.textContent = "Something went wrong. Try again."; btn.disabled = false; }
        })
        .catch(function () { if (note) note.textContent = "Something went wrong. Try again."; btn.disabled = false; });
    });
  })();

  /* ---------- scroll reveals (same class contract as the drop page) ---------- */
  if ("IntersectionObserver" in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); obs.unobserve(en.target); } });
    }, { rootMargin: "0px 0px -8% 0px" });
    document.querySelectorAll(".reveal").forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) el.classList.add("in");
      else obs.observe(el);
    });
  } else {
    document.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("in"); });
  }
})();
